import { css } from '@emotion/core';

const overrideFontVariables = css`
  /* Update Profile Font [Dumbledore] DTXOGROWTH-2173· */
  --sys-typography-heading-sm-family: PayPalPro-Black, Helvetica Neue, Arial,
    sans-serif;
  --sys-typography-heading-sm-size: 1.5rem;
  --sys-typography-heading-sm-weight: 900;
  --sys-typography-heading-sm-line-height: 2rem; /* 133.333% */
  --profile-font-style: normal;
  --profile-letter-spacing: -0.03rem;

  /* Update Subpage Head Font [Dumbledore] DTXOGROWTH-2170· */
  --sys-typography-title-lg-family: PayPalPlain-Medium, Helvetica Neue, Arial,
    sans-serif;
  --sys-typography-title-lg-size: 1.25rem;
  --sys-typography-title-lg-weight: 500;
  --sys-typography-title-lg-line-height: 1.5rem; /* 120% */
  --title-lg-font-style: normal;
  --title-lg-letter-spacing: -0.0125rem;

  /* Update Main Text Font [Dumbledore] DTXOGROWTH-2167· */
  --sys-typography-title-medium-family: PayPalPlain-Medium, Helvetica Neue,
    Arial, sans-serif;
  --sys-typography-title-medium-size: 1rem;
  --sys-typography-title-medium-weight: 500;
  --sys-typography-title-medium-line-height: 1.5rem; /* 150% */
  --title-medium-font-style: normal;
  --title-medium-letter-spacing: -0.01rem;

  /* Update Subtext Font [Dumbledore] DTXOGROWTH-2164· */
  --sys-typography-body-family: PayPalPlain-Regular, Helvetica Neue, Arial,
    sans-serif;
  --sys-typography-body-size: 0.875rem;
  --sys-typography-body-weight: 400;
  --sys-typography-body-line-height: 1.25rem; /* 142.857% */
  --body-font-style: normal;
  --body-font-feature-settings: 'liga' off, 'clig' off;
  --body-letter-spacing: -0.0175rem;

  /* Update Links [Dumbledore] DTXOGROWTH-2161· */
  --sys-typography-link-lg-family: PayPalPlain-Medium, Helvetica Neue, Arial,
    sans-serif;
  --sys-typography-link-lg-size: 0.875rem;
  --sys-typography-link-lg-weight: 500;
  --sys-typography-link-lg-line-height: 1.25rem; /* 142.857% */
  --link-lg-font-style: normal;
  --link-lg-letter-spacing: -0.0175rem;
  --link-lg-color: #0066f5;
  --link-lg-text-decoration-line: underline;
  --link-lg-text-decoration-skip-ink: none;
  --link-lg-text-decoration-style: solid;
  --link-lg-text-decoration-thickness: auto;
  --link-lg-text-underline-offset: auto;
  --link-lg-text-underline-position: from-font;

  /* Update Form Text Font [Dumbledore] DTOPPOR-3170 */
  --sys-typography-field-font-family: PayPalPlain-Regular, Helvetica Neue, Arial,
    sans-serif;
  --sys-typography-field-letter-sm-spacing: -1%;
  --sys-typography-field-letter-lg-spacing: -2%;
  --sys-typography-field-weight: 400;
  --sys-typography-field-label-sm-font-size: 12px;
  --sys-typography-field-label-sm-line-height: 20px;
  --sys-typography-field-label-lg-font-size: 14px;
  --sys-typography-field-label-lg-line-height: 24px;
  --sys-typography-field-value-sm-font-size: 14px;
  --sys-typography-field-value-sm-line-height: 24px;

  /* Black link styling */
  --link-black-color: #001435;
  --sys-typography-link-black-family: PayPalPlain-Bold, Helvetica Neue, Arial,
    sans-serif;
  --sys-typography-link-black-weight: 700;
  --link-black-text-decoration: none;

  /* Update badges [Dumbledore] DTXOGROWTH-2158· */
  --badge-color: #000;
  --badge-font-feature-settings: 'liga' off, 'clig' off;
  --badge-text-align: center;

  /* Button Font */
  --sys-typography-button-lg-family: PaypalPro-Black, Helvetica Neue, Arial,
    sans-serif;
  --sys-typography-button-lg-size: 0.875rem;
  --sys-typography-button-lg-weight: 900;
  --sys-typography-button-lg-line-height: 1.125rem;
  --sys-typography-body-lg-bold-weight: 700;
`;

const titleLgStyles = css`
  font-family: var(--sys-typography-title-lg-family);
  font-size: var(--sys-typography-title-lg-size);
  font-style: var(--title-lg-font-style);
  font-weight: var(--sys-typography-title-lg-weight);
  letter-spacing: var(--title-lg-letter-spacing);
  line-height: var(--sys-typography-title-lg-line-height);
`;

const bodyLgMediumStyles = css`
  font-family: var(--sys-typography-title-medium-family);
  font-size: var(--sys-typography-title-medium-size);
  font-style: var(--title-medium-font-style);
  font-weight: var(--sys-typography-title-medium-weight);
  letter-spacing: var(--title-medium-letter-spacing);
  line-height: var(--sys-typography-title-medium-line-height);
`;

const bodyLgStyles = css`
  ${bodyLgMediumStyles}
  font-family: var(--sys-typography-body-family);
  font-weight: var(--sys-typography-body-weight);
`;

const bodyStyles = css`
  font-family: var(--sys-typography-body-family);
  font-size: var(--sys-typography-body-size);
  font-style: var(--body-font-style);
  font-weight: var(--sys-typography-body-weight);
  letter-spacing: var(--body-letter-spacing);
  line-height: var(--sys-typography-body-line-height);
`;

const buttonLgStyles = css`
  font-family: var(--sys-typography-button-lg-family);
  font-size: var(--sys-typography-button-lg-size);
  font-weight: var(--sys-typography-button-lg-weight);
  line-height: var(--sys-typography-button-lg-line-height);
`;

const linkLgStyles = css`
  color: var(--link-lg-color);
  font-family: var(--sys-typography-link-lg-family);
  font-size: var(--sys-typography-link-lg-size);
  font-style: var(--link-lg-font-style);
  font-weight: var(--sys-typography-link-lg-weight);
  letter-spacing: var(--link-lg-letter-spacing);
  line-height: var(--sys-typography-link-lg-line-height);
  text-decoration-line: var(--link-lg-text-decoration-line);
  text-decoration-skip-ink: var(--link-lg-text-decoration-skip-ink);
  text-decoration-style: var(--link-lg-text-decoration-style);
  text-decoration-thickness: var(--link-lg-text-decoration-thickness);
  text-underline-offset: var(--link-lg-text-underline-offset);
  text-underline-position: var(--link-lg-text-underline-position);
`;

const linkBlackStyles = css`
  color: var(--link-black-color);
  font-family: var(--sys-typography-link-black-family);
  font-weight: var(--sys-typography-link-black-weight);
  text-decoration: var(--link-black-text-decoration);
`;

const interstitialStyles = css`
  article div[class*='modal_header_title-text'] {
    ${titleLgStyles}
  }
`;

const bodyMediumStyles = css`
  ${bodyStyles}
  font-family: var(--sys-typography-title-medium-family);
  font-weight: var(--sys-typography-title-medium-weight);
`;

const headingSmStyles = css`
  font-family: var(--sys-typography-heading-sm-family);
  font-size: var(--sys-typography-heading-sm-size);
  font-style: var(--profile-font-style);
  font-weight: var(--sys-typography-heading-sm-weight);
  letter-spacing: var(--profile-letter-spacing);
  line-height: var(--sys-typography-heading-sm-line-height);
`;

const bodyLgBoldStyles = css`
  ${bodyLgMediumStyles}
  font-weight: var(--sys-typography-body-lg-bold-weight);
`;

//had to disable stylelint because eslint is confliting with it
/* stylelint-disable */
const floatingInputs = css`
  /* Style overrides for font size on form fields */
  input[class*='FloatingLabelInput'] ~ label,
  select[class*='FloatingLabelSelect'] ~ label,
  input[class*='FloatingLabelInput'],
  select[class*='FloatingLabelSelect'] {
    font-family: var(--sys-typography-field-font-family);
    font-weight: var(--sys-typography-field-weight);
    letter-spacing: var(--sys-typography-field-letter-sm-spacing);
  }

  input[class*='FloatingLabelInput']:not(
      [autocomplete='tel']
    ):placeholder-shown:not(:focus)
    ~ label,
  select[class*='FloatingLabelSelect']:has(option:first-child:checked):not(
      :focus
    )
    ~ label {
    font-size: var(--sys-typography-field-label-lg-font-size);
    letter-spacing: var(--sys-typography-field-letter-lg-spacing);
    line-height: var(--sys-typography-field-label-lg-line-height);
    top: 18px;
  }

  input[class*='FloatingLabelInput'][autocomplete='tel'] ~ label,
  input[class*='FloatingLabelInput']:focus ~ label,
  select[class*='FloatingLabelSelect']:focus ~ label,
  input[class*='FloatingLabelInput']:not(:placeholder-shown) ~ label,
  select[class*='FloatingLabelSelect']:not(:has(option:first-child:checked))
    ~ label {
    font-size: var(--sys-typography-field-label-sm-font-size);
    line-height: var(--sys-typography-field-label-sm-line-height);
  }

  div[class*='PhoneInputContainer']:has(div[class*='FloatingLabelContainer'])
    span:first-child,
  input[class*='FloatingLabelInput'],
  select[class*='FloatingLabelSelect'] {
    font-size: var(--sys-typography-field-value-sm-font-size);
    line-height: var(--sys-typography-field-value-sm-line-height);
  }

  [class*='ErrorContainer-FieldError'] p {
    ${bodyStyles}
  }

  #password-hints span {
    ${bodyStyles}
  }
`;

const fontRebrandingStyles = css`
  /* Update Profile Font [Dumbledore] DTXOGROWTH-2173· */
  .overrides-font-4-2.heading-sm {
    ${headingSmStyles}
  }

  /* Update Subpage Head Font [Dumbledore] DTXOGROWTH-2170· Same as body-lg-medium  */
  .overrides-font-4-2.title-lg {
    ${titleLgStyles}
  }

  /* Update Main Text Font [Dumbledore] DTXOGROWTH-2167· */
  .overrides-font-4-2.body-lg-medium,
  .overrides-font-4-2.body-lg:not(.title-lg) {
    ${bodyLgMediumStyles}
  }

  .overrides-font-4-2.body-lg:not(.title-lg) {
    font-family: var(--sys-typography-body-family);
    font-weight: var(--sys-typography-body-weight);
  }

  /* Update Subtext Font [Dumbledore] DTXOGROWTH-2164· */
  .overrides-font-4-2.body-medium,
  .overrides-font-4-2.body {
    ${bodyStyles}
  }

  .overrides-font-4-2.body-medium {
    ${bodyMediumStyles}
  }

  /* Update Links [Dumbledore] DTXOGROWTH-2161· */

  .overrides-font-4-2.link-lg:not(.body-medium, .body-lg-medium),
  .overrides-font-4-2.link-lg:not(.body-medium, .body-lg-medium):visited {
    ${linkLgStyles}
  }

  .overrides-font-4-2.link-lg.link-black:not(.body-medium, .body-lg-medium),
  .overrides-font-4-2.link-lg.link-black:not(
      .body-medium,
      .body-lg-medium
    ):visited {
    ${linkBlackStyles}
  }

  /* Update badges [Dumbledore] DTXOGROWTH-2158· */
  .overrides-font-4-2.badge-body {
    font-family: var(--sys-typography-body-family);
    font-feature-settings: var(--badge-font-feature-settings);
    font-size: var(--sys-typography-body-size);
    font-style: var(--body-font-style);
    font-weight: var(--sys-typography-body-weight);
    line-height: var(--sys-typography-body-line-height);
    text-align: var(--badge-text-align);
  }

  /* feat(dumbledore): DTXOGROWTH-1833 - Update Form Fields and Text Colors */
  .overrides-font-4-2.field-label-sm,
  .overrides-font-4-2.field-label-lg,
  .overrides-font-4-2.field-value-sm {
    font-family: var(--sys-typography-field-font-family);
    font-weight: var(--sys-typography-field-weight);
    letter-spacing: var(--sys-typography-field-letter-sm-spacing);
  }

  .overrides-font-4-2.field-label-sm {
    font-size: var(--sys-typography-field-label-sm-font-size);
    line-height: var(--sys-typography-field-label-sm-line-height);
  }

  .overrides-font-4-2.field-label-lg {
    font-size: var(--sys-typography-field-label-lg-font-size);
    letter-spacing: var(--sys-typography-field-letter-lg-spacing);
    line-height: var(--sys-typography-field-label-lg-line-height);
  }

  .overrides-font-4-2.field-value-sm {
    font-size: var(--sys-typography-field-value-sm-font-size);
    line-height: var(--sys-typography-field-value-sm-line-height);
  }

  .overrides-font-4-2 {
    ${overrideFontVariables}
    ${interstitialStyles}
    ${floatingInputs}
  }
`;

export {
  fontRebrandingStyles,
  titleLgStyles,
  bodyLgStyles,
  bodyLgMediumStyles,
  bodyStyles,
  linkLgStyles,
  linkBlackStyles,
  buttonLgStyles,
  bodyMediumStyles,
  headingSmStyles,
  bodyLgBoldStyles,
};
